<div class="tree-item-picker-field">
    <div class="label-container">
        <cerrix-label [for]="name">{{ label }}</cerrix-label>
        @if (infoText) {
            <cerrix-instructions-icon
                class="input-instructions-icon"
                [instructionText]="infoText"
                [showText]="false"
            ></cerrix-instructions-icon>
        }
    </div>
    <app-cerrix-picker-field
        validationErrors
        [name]="name"
        [text]="selectedItemsDescription()"
        [placeholder]="placeholder"
        (pressed)="openDialog()"
    ></app-cerrix-picker-field>
</div>

<cerrix-dialog [name]="dialogName" (closed)="validationTouched.next()">
    <div header-title>{{ dialogTitle }}</div>
    <div class="tree-item-picker-dialog-content" dialog-content>
        <div class="toolbar">
            <cerrix-search-input
                [placeholder]="'searchPlaceholder' | t"
                [value]="filter"
                (valueChange)="onFilterChange($event)"
            ></cerrix-search-input>
            <button
                type="button"
                (click)="expandAll()"
                [matTooltip]="'expandAllTooltip' | t"
            >
                <mat-icon svgIcon="open-list"></mat-icon>
            </button>
            @if (multiselect) {
                <button
                    type="button"
                    (click)="selectAll()"
                    [matTooltip]="'selectAllTooltip' | t"
                >
                    <mat-icon svgIcon="multiselect"></mat-icon>
                </button>
            }
            <button
                type="button"
                [class.active]="showSelectedOnly"
                (click)="toggleShowSelectedOnly()"
                [matTooltip]="'showSelectedTooltip' | t"
            >
                <mat-icon svgIcon="show"></mat-icon>
            </button>
            @if (multiselect) {
                <div class="divider"></div>
                <app-cerrix-checkbox
                    [value]="includeChildren"
                    (valueChange)="toggleIncludeChildren()"
                    >{{
                        "includeChildrenLabel" | t
                    }}</app-cerrix-checkbox
                >
            }
        </div>
        <app-cerrix-select-tree
            #selectTree
            [items]="items"
            [selectedIds]="draftSelection"
            (selectionChanged)="updateDraftSelection($event)"
            [iconPrefix]="iconPrefix"
            [multiselect]="multiselect"
            [includeChildren]="includeChildren"
            [showSelectedOnly]="showSelectedOnly"
            [filter]="filter"
        ></app-cerrix-select-tree>
    </div>
    <div class="tree-item-picker-dialog-footer" dialog-footer>
        <cerrix-button
            buttonType="secondary"
            secondaryColor="filled"
            buttonSize="big"
            [attr.data-uiid]="name + '-cancel'"
            (click)="cancelSelection()"
            >{{ "cancel" | t }}</cerrix-button
        >
        <cerrix-button
            buttonSize="big"
            primaryColor="green"
            [attr.data-uiid]="name + '-confirm'"
            (click)="confirmSelection()"
        >
            {{ confirmButtonLabelKey | t }}</cerrix-button
        >
    </div>
</cerrix-dialog>
